<template>
  <div class="rehome-list">
      <animals-filter :animal-categories="animalCategories" @updateCategory="updateCategory" :initial-category="initialCategory" class="scrollToHere"></animals-filter>
      <!-- Reminder to james. Stop removing the "scrollToHere" class! -->
      <vue-simple-spinner v-if="showSpinner" size="large" line-fg-color="#af1923" ></vue-simple-spinner>
      <div >
        <animal-card v-for="(animal,index) in animalsToShow" :key="animal.id" :animal="animal" :index="index"></animal-card>
      </div>
      <nav class="text-center" v-if="pageCount > 1">
         <pagination :current-page="currentPage" :total-pages="pageCount" :from-craft="false" @go-to-page="updateCurrentPage"></pagination>

        <!-- <v-pagination v-model="selectedPage" :page-count="pageCount" :classes="paginationClasses" :labels="paginationAnchorTexts" @input="updateCurrentPage"></v-pagination> -->
      </nav>

    </div>
</template>

<script>

import VueSimpleSpinner from 'vue-simple-spinner';
import vPagination from 'vue-plain-pagination';

export default {
  data() {
      return {
        animals: [],
        initialCategory: null,
        showSpinner: true,
        selectedCategory: 0,
        currentPage: 1,
        animalsPerPage: 999, // ToDo: Get pagination working
        animalsOpacity: 1,
        initialCategory: null,
        // paginationClasses: {

        //   ul: 'space-x-8',
        //   li: 'inline-block',
        //   liActive: 'text-brand-red',
        //   liDisable: 'opacity-50',
        //   button: 'font-bold'

        // },
        // paginationAnchorTexts: {
        //   first: '',
        //   prev: 'Prev',
        //   next: 'Next',
        //   last: ''
        // }
      }
    },
    props: {
      animalCategories: {
        required: true,
        type: Array
      }
    },
    components: {
      VueSimpleSpinner,
      vPagination,
    },
    mounted() {

      const query =
        `{
            entries (section: "animals") {
              title
              postDate
              ... on animals_animals_Entry {
                id
                uri
                status:applicationStatus
                animalCategory {
                  id
                  title
                }
                animalImages(limit:1) {
                  ... on AssetInterface {
                    url @transform (handle: "animal")
                  }
                }
              }
            }
        }`;

      window.axios.post('/api', {query: query}, {headers: {Authorization: window.animalsToken}})
        .then(response => {
          this.animals = response.data.data.entries;
          this.showSpinner = false;
        });

      this.setInitialSelectedCategory();

    },
computed: {
      animalsToShow() {
        return this.filteredAnimals.slice(this.animalsPerPage * (this.currentPage - 1), this.animalsPerPage * this.currentPage);
      },
      pageCount() {
        return Math.ceil(this.filteredAnimals.length / this.animalsPerPage);
      },
      filteredAnimals() {
        if (this.selectedCategory == 0) {
          return this.animals;
        }
        console.log(this.animals);
        return this.animals.filter(animal => animal.animalCategory.map(category=>category.id).includes(this.selectedCategory.toString()));
      }
    },
    methods: {
      updateCategory(category) {
         this.selectedCategory = category;
         this.currentPage = this.selectedPage = 1;
         this.updateUrl();

      },
      updateCurrentPage(newpage) {
          this.currentPage = newpage;
          document.querySelector('.scrollToHere').scrollIntoView({
            behavior: 'smooth'
          });

      },
      setInitialSelectedCategory() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('type')) {
          const categoryId = this.getArticleCategoryId(urlParams.get('type'));
          this.updateCategory(categoryId);
          this.initialCategory = categoryId;
        }
      },
      updateUrl() {
        const chosenCategory = this.selectedCategory;
        const urlParams = new URLSearchParams(window.location.search);
        // if we have 'all' selected (ie. no matching category id was found) we dont want a query string
        if (chosenCategory == 0 && urlParams.has('type')) {
          history.pushState({'category': null}, '', '/rehome');
          return;
        }
        // only push a new state to the history if its actually changing
        if (chosenCategory && urlParams.get('type') != chosenCategory) {
          history.pushState({'category': chosenCategory}, '', '/rehome?type=' + this.getArticleCategorySlug(chosenCategory));
        }
      },
      getArticleCategorySlug(id) {
        return this.animalCategories.find(category => category.id === id).slug;
      },
      getArticleCategoryId(slug) {
        return this.animalCategories.find(category => category.slug === slug).id;
      },

    }



    }

</script>